module.exports = __webpack_public_path__ + "static/media/link-assembly-mr-card-front.8f59cd44.jpeg";